import React from 'react';
import { styled } from 'styled-components';

export interface CanvasContainerProps {
  isReadOnly?: boolean;
  children: React.ReactNode;
}

const CanvasWrapper = styled.div<{ $isReadOnly: boolean }>`
  position: relative;
  height: 100%;
  width: 100%;
  border: ${({ theme, $isReadOnly }) =>
    $isReadOnly ? `2px solid ${theme.colorPrimary}` : 'none'};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  overflow: auto;
  contain: layout;
`;

const Canvas = styled.div`
  background: ${({ theme }) => theme.colorFillTertiary};
  height: 100%;
  width: 100%;
  overflow: auto;
  contain: layout;
`;

export const CanvasContainer: React.FC<CanvasContainerProps> = ({
  isReadOnly = false,
  children,
}) => {
  return (
    <CanvasWrapper $isReadOnly={isReadOnly}>
      <Canvas>{children}</Canvas>
    </CanvasWrapper>
  );
};
